import { assign } from 'lodash';

import {
  textStyles,
  colors,
  fonts,
  loadingDark,
  loadingLight
} from '../../shared/styles';

export const styles = {
  container: {
    marginBottom: 24,
    minHeight: 65,
  },
  title: {
    position: 'relative',
    minHeight: 12,
    marginBottom: 13,
    ...textStyles.sectionHead,
  },
  linkDiv: {
    borderRadius: '3px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: colors.greyLine,
    width: '108px',
    height: '35px'
  },
  link: {
    display: 'block',
    fontSize: 12,
    color: colors.grey,
    ...fonts.bold
  },
  loadingTitle: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '50%',
    height: 12,
    pointerEvents: 'none',
    ...loadingDark,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingResults: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '100%',
    height: 18,
    pointerEvents: 'none',
    ...loadingLight,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  resultYears: {
    position:'relative',
    minHeight:31
  },
  flexStyle: {
    justifyContent: 'center',
    alignContent: 'space-evenly',
    display: 'flex',
    flexWrap: 'wrap'
  },
  flexColStyle: (isMobile, display = true) => (
    assign({
      width: '108px',
      textAlign: 'center',
      flex: '0 0 47%',
      fontFamily: fonts.bold.fontFamily,
      fontSize: 12,
      hoverColor: colors.black,
      hoverBackgroundColor: colors.lightGrey,
      backgroundColor: colors.white,
      border: `1px solid ${colors.greyLine}`,
      borderRadius: 3,
      color: colors.grey,
      margin: '3px',
      boxSizing: 'border-box',
      lineHeight: '30px',
      paddingTop: '2px',
      height: '35px',
      textTransform: 'uppercase',
      display: display ? 'block' : 'none'
    },
    isMobile ?
      {
        width:'50px',
        flex: '0 0 30%'
      } :  {}
    )
  )
};



/** WEBPACK FOOTER **
 ** ./components/elpResults/styles.js
 **/